import  apiClient  from '../../../../services/apiClient';

export const invitePlansApi = {
    getList:              (page = 1, limit = 20) => apiClient.get(`invite_plans?page=${page}&limit=${limit}`),
    getOne:               (id)              => apiClient.get(`invite_plans/${id}`),
    getKgStats:           (id)              => apiClient.get(`invite_plans/${id}/kg_stats`),
    getKindergartenInvites: (id, kindergartenId) => apiClient.get(`invite_plans/${id}/kindergarten/${kindergartenId}/invites`),
    getNotifications:     (id)              => apiClient.get(`invite_plans/${id}/notifications`),
    getTrend:             (limit = 30)      => apiClient.get(`invite_plans/trend?limit=${limit}`),
    compareTwo:           (id1, id2)        => apiClient.get(`invite_plans/compare?id1=${id1}&id2=${id2}`),
    run:                  ()               => apiClient.post('invite_plans/run', {}),
    simulate:             ()               => apiClient.post('invite_plans/simulate', {}),
    rescheduleNotifications: (id, scheduledAt) => apiClient.post(`invite_plans/${id}/reschedule_notifications`, { scheduledAt }),
    retryNotifications:   (id)              => apiClient.post(`invite_plans/${id}/retry_notifications`, {}),
    getSchedulerStatus:   ()               => apiClient.get('scheduler/status'),
    getReceptionStatus:   ()               => apiClient.get('kindergartens/reception_status'),
};